import React from 'react';
import { arrayOf, bool, node, number, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';
import { TabLabel } from '../TabNavHorizontal/TabNavHorizontal';

import css from './TabNav.module.css';

const Tab = props => {
  const { className, id, disabled = false, text, count, dot, dotLabel, selected = false } = props;
  const { linkProps } = props;
  const linkClasses = classNames(css.link, {
    [css.selectedLink]: selected,
    [css.disabled]: disabled,
  });

  return (
    <div id={id} className={className}>
      <NamedLink className={linkClasses} {...linkProps}>
        <TabLabel text={text} count={count} dot={dot} dotLabel={dotLabel} />
      </NamedLink>
    </div>
  );
};

/**
 * Link tabs: a row with the family-colour underline on phones, and a side list with the
 * family-colour bar from the large breakpoint (the account and legal pages' side nav).
 */
const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs, ariaLabel } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <nav className={classes} aria-label={ariaLabel}>
      {tabs.map((tab, index) => {
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return <Tab key={id} id={id} className={tabRootClassName} {...tab} />;
      })}
    </nav>
  );
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  ariaLabel: string,
  tabs: arrayOf(
    shape({
      id: string,
      text: node.isRequired,
      // A count after the label, or a dot for something new
      count: number,
      dot: bool,
      dotLabel: string,
      disabled: bool,
      selected: bool,
      linkProps: object.isRequired,
    })
  ).isRequired,
};

export default TabNav;
